import {refreshDetails} from 'insights/analytics-dashboards/details/AnalyticsDashboardDetailsActions';

import * as AnalyticsQueryDAO from './AnalyticsQueryDAO';
import {AnalyticsQuerySpecResponse} from './RESTAnalyticsQueryTypes';

export async function cloneAnalyticsQuery(
  analyticsQueryId: string,
  data: {destinationDashboardId: string}
): Promise<AnalyticsQuerySpecResponse> {
  const clonedRESTAnalyticsQuery = await AnalyticsQueryDAO.cloneAnalyticsQuery(analyticsQueryId, data);
  await refreshDetails(data.destinationDashboardId);
  return clonedRESTAnalyticsQuery;
}

export interface AnalyticsQueryActions {
  cloneAnalyticsQuery: typeof cloneAnalyticsQuery;
}
